<template>
  <div class="sign-modal" v-show="showSign" @click.self="handleOutsideClick">
    <div class="sign-card">
      <!-- 用户头像 -->
      <div class="user-avatar">
        <img :src="userInfo.avatar" alt="用户头像" class="avatar-img" />
      </div>

      <!-- 签到表单 -->
      <div class="sign-form">
        <!-- 祝福语选择 -->
        <div class="form-item selectable" @click="showWishPicker">
          <span class="item-label">{{ $i18n('blessings', '祝愿语') }}</span>
          <div class="item-value">
            <span class="wish-text">{{ wish }}</span>
            <van-icon name="arrow" class="arrow-icon" />
          </div>
        </div>

        <!-- 签到按钮 -->
        <van-button
            round
            type="primary"
            class="sign-button"
            @click="handleSign"
        >
          <span class="button-text">{{ $i18n('checkIn', '立即签到') }}</span>
          <van-icon name="medal" class="button-icon" />
        </van-button>
      </div>
    </div>

    <!-- 使用 ActionSheet 替代 Picker -->
    <van-action-sheet
        v-model="showWish"
        :actions="wishActions"
        @select="onSelectWish"
        cancel-text="取消"
        description="请选择祝福语"
        class="wish-action-sheet"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getDefaultBless } from "@/utils/constant";
import store from "@/store";
import { Button, Icon, ActionSheet } from "vant";
import i18nMixin from "@/libs/i18nMixin";

export default {
  name: "SignModal",
  mixins: [i18nMixin],
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [ActionSheet.name]: ActionSheet
  },
  data() {
    return {
      wish: "",
      userInfo: {},
      wishActions: [],
      showWish: false,
      showSign: false
    };
  },
  computed: {
    ...mapGetters(["live"])
  },
  created() {
    this.fetchUserInfo();
  },
  methods: {
    async fetchUserInfo() {
      try {
        this.userInfo = await store.dispatch("USERINFO");
        await this.checkSignStatus();
        await this.loadWishOptions();
      } catch (error) {
        console.error("获取用户信息失败:", error);
      }
    },

    async checkSignStatus() {
      try {
        const res = await this.$http.get("/live/checkSign", {
          params: { id: this.live.id }
        });
        this.showSign = !res.data;
        // this.showSign = true;
      } catch (error) {
        console.error("检查签到状态失败:", error);
      }
    },

    async loadWishOptions() {
      try {
        const res = await this.$http.get("/api/liveBlessWord/getList", {
          params: { liveId: this.live.id }
        });

        this.wishActions = res.data.length > 0
            ? res.data.map(item => ({ name: item.name }))
            : getDefaultBless(this.live.liveTypeCode).map(item => ({ name: item.name }));

        this.wish = this.wishActions[0].name || "";
      } catch (error) {
        console.error("加载祝福语选项失败:", error);
      }
    },

    showWishPicker() {
      this.showWish = true;
    },

    onSelectWish(item) {
      this.wish = item.name;
      this.showWish = false;
    },

    async handleSign() {
      try {
        const params = {
          liveId: this.live.id,
          wish: this.wish
        };

        await this.$http.post("/live/sign", params);

        this.$toast.success(this.$i18n('check-in-Successful', '签到成功!'));
        this.$Bus.$emit("refreshCoin");
        this.$emit("onSuccess");
        this.closeModal();
      } catch (error) {
        console.error("签到失败:", error);
        this.$toast.fail(this.$i18n('checkInFailed', '签到失败，请重试'));
      }
    },

    handleOutsideClick() {
      this.handleSign();
    },

    closeModal() {
      this.showSign = false;
    }
  }
};
</script>

<style lang="less" scoped>
// 颜色变量
@primary-color: #28C76F;
@white: #ffffff;
@gray-1: #f7f7f7;
@gray-5: #cccccc;
@gray-7: #646566;
@gray-8: #323233;
@shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

// 尺寸变量
@avatar-size: 80px;
@modal-width: 280px;
@modal-padding: 20px;
@item-height: 44px;
@border-radius: 12px;

.sign-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;

  .sign-card {
    position: relative;
    width: @modal-width;
    padding: @modal-padding;
    background-color: @white;
    border-radius: @border-radius;
    box-shadow: @shadow;
    text-align: center;

    .user-avatar {
      position: absolute;
      top: -(@avatar-size / 2);
      left: 50%;
      transform: translateX(-50%);

      .avatar-img {
        width: @avatar-size;
        height: @avatar-size;
        border: 3px solid @white;
        border-radius: 50%;
        box-shadow: @shadow;
        object-fit: cover;
      }
    }

    .sign-form {
      margin-top: @avatar-size / 2 + 10px;

      .form-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: @item-height;
        padding: 0 15px;
        margin-bottom: 15px;
        background-color: @gray-1;
        border-radius: @border-radius;
        font-size: 14px;
        color: @gray-8;

        &.selectable {
          cursor: pointer;
          transition: background-color 0.2s;

          &:active {
            background-color: darken(@gray-1, 5%);
          }
        }

        .item-label {
          flex-shrink: 0;
          white-space: nowrap;
          margin-right: 10px;
        }

        .item-value {
          display: flex;
          align-items: center;
          flex: 1;
          min-width: 0;

          .wish-text {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: @gray-7;
            text-align: right;
            padding-right: 5px;
          }

          .arrow-icon {
            margin-left: 5px;
            color: @gray-5;
            flex-shrink: 0;
          }
        }
      }

      .sign-button {
        width: 100%;
        height: 44px;
        font-size: 16px;
        font-weight: 500;
        background: linear-gradient(135deg, @primary-color, darken(@primary-color, 10%));
        border: none;

        .button-text {
          margin-right: 8px;
        }

        .button-icon {
          font-size: 18px;
        }
      }
    }
  }
}

// ActionSheet 自定义样式
.wish-action-sheet {
  /deep/ .van-action-sheet__header {
    font-size: 16px;
    font-weight: bold;
    padding: 15px;
  }

  /deep/ .van-action-sheet__item {
    font-size: 15px;
    padding: 12px 15px;
  }

  /deep/ .van-action-sheet__cancel {
    padding-top: 8px;
  }
}

// 动画效果
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
